<script>
    import ShapeLoader from 'util/ShapeLoader'

    const { name } = $props()
    const icon = $derived(ShapeLoader[name])
</script>

{#if icon}
    <!-- eslint-disable-next-line svelte/no-at-html-tags -->
    {@html icon}
{/if}
